import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from '../pages/Dashboard';
import UserManagement from '../pages/User/UserManagement';
import PermissionList from '../pages/Permission/PermissionList';
import RoleList from '../pages/Role/RoleList';
import Login from '../pages/Login';
import AdminUserManagement from '../pages/System/AdminUserManagement';
import Settings from '../pages/Settings';
import AIConfigPage from '../pages/AIManagement/AIConfigPage';
import AIConnectivityTestPage from '../pages/AIManagement/AIConnectivityTestPage';
import AICostMonitorPage from '../pages/AIManagement/AICostMonitorPage';
import StorageConfigPage from '../pages/Storage/StorageConfigPage';
import ResourceListPage from '../pages/Storage/ResourceListPage';
import BackgroundMusicPage from '../pages/Storage/BackgroundMusicPage';
import SleepVideoPage from '../pages/Storage/SleepVideoPage';
import UserVoicesPage from '../pages/Storage/UserVoicesPage';
import DataPullPage from '../pages/DataPull/DataPullPage';
import DownloadManagement from '../pages/Download/DownloadManagement';
import { QuickRouterCoreTest } from '../pages/CoreTest/CoreTestManagement';
import VoiceManagement from '../pages/ContentOps/VoiceManagement';
import LoginConfigPage from '../pages/LoginConfig/LoginConfigPage';
import GenerationConfigPage from '../pages/GenerationConfig/GenerationConfigPage';
import PolarisReportingPage from '../pages/Polaris/PolarisReportingPage';
import AdConfigPage from '../pages/AdConfig/AdConfigPage';
import AnalyticsPage from '../pages/Analytics/AnalyticsPage';

const AppRoutes: React.FC = () => {
  // 检查登录状态
  const isAuthenticated = !!localStorage.getItem('token');

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="permissions" element={<PermissionList />} />
        <Route path="roles" element={<RoleList />} />
        <Route path="system/admins" element={<AdminUserManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="settings/login-config" element={<LoginConfigPage />} />
        <Route path="settings/ads" element={<AdConfigPage />} />
        <Route path="settings/generation" element={<Navigate to="/generation/config" replace />} />
        <Route path="generation" element={<Navigate to="/generation/config" replace />} />
        <Route path="generation/config" element={<GenerationConfigPage />} />
        <Route path="polaris" element={<PolarisReportingPage />} />
        <Route path="content/voices" element={<VoiceManagement />} />
        <Route path="content/scene-tags" element={<Navigate to="/content/voices" replace />} />
        <Route path="content/schedule-templates" element={<Navigate to="/content/voices" replace />} />
        <Route path="resource/list" element={<ResourceListPage />} />
        <Route path="resource/background-music" element={<BackgroundMusicPage />} />
        <Route path="resource/sleep-videos" element={<SleepVideoPage />} />
        <Route path="content/user-voices" element={<UserVoicesPage />} />
        <Route path="resource/storage" element={<StorageConfigPage />} />
        <Route path="download/releases" element={<DownloadManagement />} />
        <Route path="data-pull" element={<Navigate to="/data-pull/sleep-videos" replace />} />
        <Route path="data-pull/sleep-videos" element={<DataPullPage type="sleep-videos" />} />
        <Route path="data-pull/sleep-music" element={<DataPullPage type="sleep-music" />} />
        <Route path="system/storage" element={<Navigate to="/resource/storage" replace />} />
        <Route path="ai-management/config" element={<AIConfigPage />} />
        <Route path="ai-management/test" element={<AIConnectivityTestPage />} />
        <Route path="ai-management/costs" element={<AICostMonitorPage />} />
        <Route path="core-test" element={<Navigate to="/core-test/quickrouter" replace />} />
        <Route path="core-test/quickrouter" element={<QuickRouterCoreTest />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
